import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { cn } from '@/lib/utils';

type UserRole = 'athlete' | 'parent' | 'club_coach' | 'college_coach';

interface RoleOption {
  id: UserRole;
  emoji: string;
  title: string;
  description: string;
}

const roleOptions: RoleOption[] = [
  {
    id: 'athlete',
    emoji: '🏀',
    title: 'Athlete',
    description: 'High school or college athlete'
  },
  {
    id: 'parent',
    emoji: '👨‍👩‍👧',
    title: 'Parent',
    description: 'Parent of an athlete'
  },
  {
    id: 'club_coach',
    emoji: '🏆',
    title: 'Club Coach',
    description: 'Club or travel team coach'
  },
  {
    id: 'college_coach',
    emoji: '🎓',
    title: 'College Coach',
    description: 'College program coach'
  }
];

interface MobileRoleSelectionProps {
  onBack: () => void;
  onSelectRole: (role: UserRole) => void;
}

const MobileRoleSelection: React.FC<MobileRoleSelectionProps> = ({ onBack, onSelectRole }) => {
  return (
    <div className="flex flex-col min-h-screen bg-background p-6">
      {/* Back button */}
      <button
        onClick={onBack}
        className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors mb-6"
      >
        <ArrowLeft className="h-5 w-5" />
        <span>Back to Login</span>
      </button>

      {/* Header */}
      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold text-foreground mb-2">I am a...</h1>
        <p className="text-muted-foreground">Select your role to get started</p>
      </div>

      {/* Role Cards */}
      <div className="grid gap-4">
        {roleOptions.map((role) => (
          <button
            key={role.id}
            onClick={() => onSelectRole(role.id)}
            className={cn(
              "flex items-center gap-4 p-5 rounded-xl border-2 border-border",
              "bg-card hover:bg-accent hover:border-primary transition-all",
              "text-left active:scale-[0.98]"
            )}
          >
            <div className="text-4xl">{role.emoji}</div>
            <div>
              <h3 className="font-semibold text-lg text-foreground">{role.title}</h3>
              <p className="text-sm text-muted-foreground">{role.description}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MobileRoleSelection;
